import { css } from '@emotion/core'
import React from 'react'
import { H5 } from '@fs/zion-ui'

const sectionHeading = css`
  padding: 16px;
`
export default function SectionHeading({ heading }) {
  return (
    <div css={sectionHeading}>
      <H5>{heading}</H5>
    </div>
  )
}
